import { useQuery } from '@tanstack/react-query';
import {
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Select,
  TimePicker,
} from 'antd';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getPractitioners } from '../../../network/practitioners';
import { getAppointments } from '../../../network/appointment';
import { getEncountersDetails } from '../../../network/encounters';

const EncounterInformation = ({ t, form, edit, id, setShowTeeth,setShowBody }) => {
  const { data: encountersInfo, isLoading: encountersInfoLoading } = useQuery({
    queryKey: [queryKeys.getEncountersDetails, id],
    queryFn: () => getEncountersDetails(id),
    keepPreviousData: true,
    enabled: !!edit,
  });

  const { data: appointments } = useQuery({
    queryKey: [queryKeys.getAppointments],
    queryFn: getAppointments,
    keepPreviousData: true,
  });

  useEffect(() => {
    if (encountersInfo && edit) {
      const customFileNumber = appointments?.message?.message?.find(
        (item) => item?.name === encountersInfo?.message?.message?.appointment
      );
      form.setFieldsValue({
        custom_file_number: customFileNumber?.custom_file_number || '',
      });
      const appointmentData = appointments?.message?.message?.find(
        (x) => x?.name === encountersInfo?.message?.message?.appointment
      );
      console.log(appointmentData, 'in edit appointmentData');
      onChangeAppointment(appointmentData?.id, { data: appointmentData });
    }
  }, [encountersInfo, edit, form, appointments]);

  useEffect(() => {
    if (id && appointments) {
      const appointmentData = appointments?.message?.message?.find(
        (x) => x?.name === id
      );
      onChangeAppointment(appointmentData?.id, { data: appointmentData });
    }
  }, [id, appointments]);

  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };

  const onChangeAppointment = (value, option) => {
    console.log(value, option, 'params');
    const appointmentData = option?.data;
    // setShowTeeth(appointmentData?.department === 'Biochemistry')
    console.log(appointmentData, 'appointmentData in onChangeAppointment');
    if (appointmentData) {
      setShowTeeth(
        appointmentData?.department ===
          'Dental'
      );
      setShowBody(appointmentData?.department === 'Dermatology');
      // const birthDate = dayjs(appointmentData?.patient_age);
      // const today = dayjs();
      // const years = today.diff(birthDate, 'year', true);
      // const months = today.diff(birthDate, 'month') % 12;
      // console.log(years, months, 'years, months');
      form.setFieldsValue({
        patient: appointmentData?.patient,
        // patient: appointmentData?.patient,
        patient_name: appointmentData?.patient_name,
        patient_age: appointmentData?.patient_age,
        // patient_age: `${Math.floor(years)} years ${months} months`,
        patient_sex: appointmentData?.patient_sex,
        practitioner: appointmentData?.practitioner,
        practitioner_name: appointmentData?.practitioner_name,
        medical_department: appointmentData?.department,
        appointment_type: appointmentData?.appointment_type,
      });
    }
  };

  const appointmentValue = Form.useWatch('appointment', form);
  console.log(appointmentValue, 'appointmentValue');
  // const handleGetAppointmentsInfo = (value) => {
  //   if (value) {
  //     getAppointments(value);
  //     const appointmentData = appointments?.message?.message?.find(x => x?.id === value)
  //   }
  // }
  // handleGetAppointments(appointmentValue);

  return (
    <>
      <Divider orientation="left">{t.encounterInformation}</Divider>
      <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item
          name="appointment"
          label={t.appointments}
          rules={[{ required: true, message: t.requiredAppointment }]}
        >
          <Select
            placeholder={t.appointments}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.label.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA?.label
                .toLowerCase()
                .localeCompare(optionB?.label.toLowerCase())
            }
            onChange={onChangeAppointment}
            options={appointments?.data?.map((appointment) => ({
              value: appointment?.name,
              label: appointment?.name,
              data: appointment,
            }))}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item
          name="patient"
          label={t.patientFileNumber}
          // rules={[{ required: true, message: t.requiredpatientFileNumber }]}
        >
          <Input placeholder={t.patientFileNumber} disabled />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item
          name="patient_name"
          label={t.patientName}
          // rules={[{ required: true, message: t.requiredPatientName }]}
        >
          <Input placeholder={t.patientName} disabled />
        </Form.Item>
      </Col>
      {/* <Form.Item name="patient" hidden>
        <Input disabled />
      </Form.Item> */}
      <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item name="patient_sex" label={t.gender}>
          <Input placeholder={t.gender} disabled />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item name="patient_age" label={t.patientAge} disabled>
          <Input placeholder={t.patientAge} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item name="practitioner_name" label={t.healthcarePractitioner}>
          <Input placeholder={t.healthcarePractitioner} disabled />
        </Form.Item>
      </Col>
      <Form.Item name="practitioner" hidden>
        <Input />
      </Form.Item>
      {/* <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item
          name="practitioner"
          label={t.healthcarePractitioner}
          rules={[{ required: true, message: t.requiredPractitioner }]}
        >
          <Select
            placeholder={t.healthcarePractitioner}
            disabled
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.label.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA?.label
                .toLowerCase()
                .localeCompare(optionB?.label.toLowerCase())
            }
            onChange={onChangePractitioner}
            options={practitioners?.message?.message?.map((practitioner) => ({
              value: practitioner?.name,
              label: practitioner?.practitioner_name,
              data: practitioner,
            }))}
          />
        </Form.Item>
      </Col> */}
      <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item name="medical_department" label={t.department}>
          <Input placeholder={t.department} disabled />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item name="appointment_type" label={t.appointmentType}>
          <Input placeholder={t.department} disabled />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8} lg={8}></Col>
      <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item
          name="encounter_date"
          label={t.encounterDate}
          initialValue={dayjs()}
          rules={[{ required: true, message: t.requiredEncounterDate }]}
        >
          <DatePicker
            defaultValue={dayjs()}
            style={{ width: '100%' }}
            disabledDate={disabledDate}
            format="DD/MM/YYYY"
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8} lg={8}>
        <Form.Item
          name="encounter_time"
          label={t.encounterTime}
          initialValue={dayjs()}
          rules={[{ required: true, message: t.requiredEncounterTime }]}
        >
          <TimePicker
            defaultValue={dayjs()}
            style={{ width: '100%' }}
            use12Hours
            format="HH:mm"
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default EncounterInformation;
